import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import NoteType from '@/models/Notes/NoteType';

export default class UpdateNoteRequest extends BaseUpdateRequest {
    description: string;
    type: NoteType;
    noteCategoryId: string;
}